package org.zest.insan_360_website.components.widgets

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import org.zest.insan_360_website.data.page_states.AuthState
import org.zest.insan_360_website.model.UserRole

@Composable
fun RoleGate(
    vararg allowedRoles: UserRole,
    ctx: PageContext,
    content: @Composable () -> Unit
) {
    if (AuthState.role !in allowedRoles) {
        LaunchedEffect(Unit) {
            ctx.router.navigateTo("/user", UpdateHistoryMode.REPLACE)
        }
    } else {
        content()
    }
}
